var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{ref:"datetime",staticClass:"form-control mt-4",attrs:{"label":"Departure Date/Time","icon":"mdi-calendar","value":_vm.value,"name":_vm.name},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }